<template>
  <div>
    <v-dialog scrollable v-model="dialog" max-width="1024">
      <v-card flat pa-0>
        <v-toolbar flat dense color="theme_primary" class="white--text">
          <v-spacer></v-spacer>
          <v-toolbar-title class="white-text"
            >Offer Salesforce Sync</v-toolbar-title
          >

          <v-spacer></v-spacer>
          <v-toolbar-side-icon>
            <v-icon color="white" @click="closeDialog()">close</v-icon>
          </v-toolbar-side-icon>
        </v-toolbar>
        <v-card-text height="100%">
          <v-layout justify-space-between pa-3>
            <v-flex xs5 pr-0>
              <v-subheader
                >{{
                  offerDemand.opportunity &&
                  offerDemand.opportunity.companies.length
                }}
                interested {{ isOffer ? "customers" : "suppliers" }} distributed
                in {{ Object.keys(offerPorts()).length }} ports:</v-subheader
              >
              <v-list two-line dense>
                <template v-for="(companies, port) in offerPorts()">
                  <v-list-tile
                    ripple
                    @click="selected_port = selected_port == port ? '' : port"
                    :key="port"
                    avatar
                    :class="selected_port == port ? 'portList' : ''"
                  >
                    <!-- :disabled="offerDemand.ports.map(e => e.name).includes(port)" -->
                    <v-list-tile-avatar>
                      <v-icon
                        v-if="
                          offerDemand.ports.map((e) => e.name).includes(port)
                        "
                        color="#00a2e1"
                        >cloud</v-icon
                      >
                      <v-icon v-else>mdi-ferry</v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>
                        <v-tooltip right>
                          <span slot="activator">
                            <flag
                              :iso="
                                ports.find((p) => p.name == port).country
                                  .iso_code
                              "
                            />
                            <span class="pl-1">{{ port }}</span>
                          </span>
                          <span>
                            <flag
                              :iso="
                                ports.find((p) => p.name == port).country
                                  .iso_code
                              "
                            />
                            <span class="pl-1">{{
                              ports.find((p) => p.name == port).country.name
                            }}</span>
                          </span>
                        </v-tooltip>
                      </v-list-tile-title>
                      <v-list-tile-sub-title>
                        <!-- <span>{{companies.map(e => e.name).join(', ')}}</span> -->
                        <span>
                          <v-tooltip right>
                            <v-icon
                              class="pr-1"
                              size="14"
                              slot="activator"
                              color="#ccc"
                              >help</v-icon
                            >
                            <template v-for="customer in companies">
                              <span :key="customer.name">
                                <v-icon dark small class="pr-2">store</v-icon>
                                {{ customer.name }}
                                <br />
                              </span>
                            </template>
                          </v-tooltip>
                          {{
                            companies.length +
                            (companies.length > 1
                              ? " customers"
                              : " customer") +
                            " interested"
                          }}
                        </span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </v-flex>
            <v-flex xs1 text-xs-center>
              <v-divider vertical></v-divider>
            </v-flex>
            <v-flex xs7 v-if="selected_port == ''">
              <v-container fill-height text-xs-center>
                <v-layout align-center justify-center column wrap>
                  <div style="width: 100%;">
                    <v-flex xs12>
                      <v-icon color="primary" size="72">mdi-ferry</v-icon>
                    </v-flex>
                    <v-flex xs12 pt-4>
                      Select a
                      <b>Port Of Destination (POD)</b>
                    </v-flex>
                    <v-layout row wrap justify-align-center class="pt-4">
                      <v-flex xs5>
                        <strong class="primary--text title capitalize">{{
                          offerDemand.port.name.replace(".", "").toUpperCase()
                        }}</strong>
                      </v-flex>
                      <v-flex xs2>
                        <v-icon small class="px-1">mdi-arrow-right-bold</v-icon>
                      </v-flex>
                      <v-flex xs5>
                        <strong class="primary--text title">...</strong>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-layout>
              </v-container>
            </v-flex>

            <v-flex xs7 v-else>
              <template v-for="(companies, port) in offerPorts()">
                <v-flex :key="port" v-show="selected_port == port" fill-height>
                  <v-container
                    fill-height
                    text-xs-center
                    v-if="offerDemand.ports.map((e) => e.name).includes(port)"
                  >
                    <v-layout
                      align-center
                      text-xs-center
                      justify-center
                      column
                      wrap
                    >
                      <div>
                        <v-flex xs12>
                          <img
                            alt="Salesforce"
                            :src="
                              require('../../../public/public_images/salesforce_logo_big.png')
                            "
                            width="120"
                            height="120"
                            contain
                            aspect-ratio="1"
                          />
                        </v-flex>
                        <v-flex xs12 pt-4>
                          <v-icon small color="success" class="pr-2"
                            >check</v-icon
                          >Synced with
                          <b>Salesforce Platform</b>
                        </v-flex>
                        <v-btn small color="primary" @click="resync(port)">
                          Resync
                        </v-btn>
                      </div>
                    </v-layout>
                  </v-container>
                  <v-card style="height: 100%;" flat v-else>
                    <v-card-text class="pt-0 px-0">
                      <offerByPort
                        :port="port"
                        :companies="companies"
                        :offerDemand="offerDemand"
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
              </template>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-flex px-4>
          <v-divider></v-divider>
        </v-flex>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" flat color="red">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div @click.stop="openDialog()">
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          dark
          depressed
          solo
          round
          small
          :color="
            synchedofferPorts() == Object.keys(this.offerPorts()).length &&
            synchedofferPorts()
              ? 'success'
              : '#00a2e1'
          "
        >
          <v-icon small class="pr-2">cloud</v-icon>
          {{ synchedofferPorts() }}/{{ Object.keys(this.offerPorts()).length }}
        </v-btn>
        <span v-if="Object.keys(this.offerPorts()).length > 0">
          <template v-for="(companies, port) in offerPorts()">
            <v-flex :key="port">
              <v-icon
                small
                class="pr-2"
                :color="
                  offerDemand.ports.map((e) => e.name).includes(port)
                    ? 'success'
                    : 'error'
                "
                >check</v-icon
              >
              {{ port }}
              <br />
            </v-flex>
          </template>
        </span>
        <span v-else>No Port Of Destination match offer's parameters</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import UPDATE_OFFER_PORT from "../../graphql/offers/update.gql";
import offerByPort from "./offerByPort.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    offerByPort,
  },
  computed: {
    ...mapGetters("commonStore", ["companies", "ports"]),
  },
  data() {
    return {
      dialog: false,
      tab: "",
      selected_port: "",
    };
  },
  props: {
    offerDemand: {
      type: Object,
      required: true,
    },
    isOffer: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    resync(port) {
      const portId = this.ports.find((e) => e.name == port).id;
      const portIds = this.offerDemand.port_ids.filter((pId) => pId !== portId);
      this.sendMutation("no-notif", "", UPDATE_OFFER_PORT, {
        id: this.offerDemand.id,
        port_ids: portIds,
      });
    },
    synchedofferPorts() {
      let tot = 0;
      Object.keys(this.offerPorts()).forEach((port) => {
        tot += this.offerDemand.ports.map((e) => e.name).includes(port);
      });
      return tot;
    },
    offerPorts() {
      let ports = [];
      let obj = {};
      if (this.isOffer) {
        if (!this.offerDemand.opportunity) return {};
        ports = this.offerDemand.opportunity.companies.map((company) => {
          if (!company.customer) return;
          company.customer.ports
            .map((port) => port.name)
            .forEach((name) => {
              if (!obj[name]) obj[name] = [];
              obj[name].push(company);
            });
        });
      }

      return obj;
    },

    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
.portList {
  background: var(--v-primary-base);
}

.portList .v-list__tile__content {
  color: white !important;
}

.portList .v-list__tile__content .v-list__tile__sub-title {
  color: white !important;
}

.portList i {
  color: white !important;
}
</style>
